module.exports = __webpack_public_path__ + "static/JamieAlaniz-7bf1af43bce5eb51ddfad7bca83a1ca2.jpeg";